import { Helmet } from 'react-helmet';
import { TSeoConfigAemProp } from '../../model/AemDataProps';

const DocumentHead = ({ aemSeoProps }: { aemSeoProps: TSeoConfigAemProp }) => {
  const pageTitle = aemSeoProps.google.pageTitle.replace('<sup>MC</sup>', '🅪');
  const description = aemSeoProps.google.description;
  return (
    <Helmet>
      {pageTitle && <title data-testId={'title'}>{pageTitle}</title>}
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default DocumentHead;
